import "./BottomSheet.css";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export const BottomSheet = ({ isOpen, onClose, children, className = "" }: Props) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="bottom-sheet-overlay" onClick={onClose}>
      <div className={`bottom-sheet ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className="bottom-sheet-handle" />

        {children}
      </div>
    </div>
  );
};
